import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import DashboardLayout from "./DashboardLayout";
import PackagesSection from "./PackagesSection";
import { clearAuthUser, getAuthUser } from "../utils/auth";

export default function PackagesDashboard() {
  const navigate = useNavigate();
  const user = useMemo(() => getAuthUser(), []);

  const handleSignOut = () => {
    clearAuthUser();
    navigate("/login", { replace: true });
  };

  return (
    <DashboardLayout user={user} onSignOut={handleSignOut} activeKey="packages">
      {({ displayName }) => (
        <div className="space-y-8">
          <PackagesSection
            title="Packages"
            subtitle="Discover our presale tiers and secure your position with exclusive SynergyCoin rewards."
            breadcrumb={["Dashboard", "Packages"]}
            onBack={() => navigate(-1)}
            fullWidth
            largeCards
          />

          {/* <div className="rounded-3xl border border-white/5 bg-white/5 p-6 text-sm text-white/70 sm:p-8">
            <p>
              Tip: once you pick a package, head over to the checkout page to complete your
              purchase and unlock your referral rewards instantly. Need help deciding? Reach out
              through the community tab and get guidance from fellow members like {displayName}.
            </p>
          </div> */}
        </div>
      )}
    </DashboardLayout>
  );
}
